import React, { useState } from "react";
import { FiArrowRightCircle, FiArrowLeftCircle } from "react-icons/fi";
import "../styles.css";

import { ReactComponent as IntaglioIcon} from './assets/IntaglioIcon.svg';
import { ReactComponent as CompressioneIcon} from './assets/CompressioneIcon.svg';
import { ReactComponent as TraveTraveIcon} from './assets/TraveTraveIcon.svg';
import { ReactComponent as BasePannelloIcon} from './assets/BasePannelliIcon.svg';
import { ReactComponent as RinforzoTraveIcon} from './assets/RinforzoTraveIcon.svg';
import { ReactComponent as RipristinoCompletoIcon} from './assets/RipristinoCompletoIcon.svg';
import { ReactComponent as StaffaTIcon} from './assets/StaffaTIcon.svg';
import { ReactComponent as CoibenteIcon} from './assets/CoibenteIcon.svg';
import { ReactComponent as SolaioIcon} from './assets/SolaioIcon.svg';
import { ReactComponent as RoofroxCheck} from './assets/RoofroxCheck.svg';
import { ReactComponent as RevitIcon} from './assets/RevitIcon.svg';

import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "../Formnode.js";

function RoofRoxSidebar() {
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const { t } = useTranslation();

  return (
    <Sidebar className="app bg-opacity-90" collapsed={collapsed}>
      <div className="closemenu" onClick={handleToggleSidebar}>
        {collapsed ? <FiArrowRightCircle /> : <FiArrowLeftCircle />}
      </div>
      <Menu className="bg-opacity-90">
        <MenuItem icon={<RoofroxCheck />} className="menu1 bg-opacity-90 inline" component={<Link to="/" className="link" />}>
          <div className="closemenu" onClick={handleToggleSidebar}>
            {collapsed ? <FiArrowRightCircle /> : <FiArrowLeftCircle />}
          </div>
          KEYPRO SUITE
        </MenuItem>
        <MenuItem icon={<IntaglioIcon />} component={<Link to="Intaglio" className="link" />}> {t("Intaglio")} </MenuItem>
        <MenuItem icon={<CompressioneIcon />} component={<Link to="Compressione" className="link" />}> {t("Compressione")} </MenuItem>
        <MenuItem icon={<TraveTraveIcon />} component={<Link to="TraveTrave" className="link" />}> {t("TraveTrave")}  </MenuItem>
        <MenuItem icon={<BasePannelloIcon />} component={<Link to="AncoraggioBase" className="link" />}> {t("AncoraggioBaseShort")} </MenuItem>
        <MenuItem icon={<RipristinoCompletoIcon />} component={<Link to="GiuntoRipristino" className="link" />}> {t("GiuntoRipristinoShort")} </MenuItem>
        <MenuItem icon={<StaffaTIcon />} component={<Link to="StaffaT" className="link" />}> {t("StaffaTShort")} </MenuItem>
        <MenuItem icon={<RinforzoTraveIcon />} component={<Link to="RinforzoTrave" className="link" />}> {t("RinforzoTraveShort")} </MenuItem>
        <MenuItem icon={<CoibenteIcon />} component={<Link to="FissaggioCoibente" className="link" />}> {t("FissaggioCoibenteShort")} </MenuItem>
        <MenuItem icon={<RevitIcon />} component={<Link to="Revit" className="link" />}> {t("Revit")} </MenuItem>
        {/* <MenuItem icon={<SolaioIcon />} component={<Link to="SolaioCollaborante" className="link" />}> {t("SolaioCollaboranteShort")} </MenuItem> */}
      </Menu>
    </Sidebar>
  );
}
export default RoofRoxSidebar;
